import React, {useState, useEffect} from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Row,
  Col,
  FormGroup,
} from "reactstrap";
import PropTypes from "prop-types";
import Loader from "../Loader";
import ZeusButton from "../../components/Button";
import SelectCreator from "../../components/Forms/components/SelectCreator";
import {requestOrgUsers, changeOwner} from "../../redux/Actions/users.action";
import {getOrgUsers} from "../../redux/Selectors/users.selector";
import {useSelector, useDispatch} from "react-redux";

const ChangeOwner = (props) => {
  const {open, onClose} = props;
  const [owner, setOwner] = useState();
  const dispatch = useDispatch();
  const user_options = useSelector(getOrgUsers);

  useEffect(() => {
    dispatch(requestOrgUsers());
  }, [dispatch]);

  const handleChange = (e) => {
    setOwner(e?.target?.value);
  };
  const handleSubmit = () => {
    dispatch(changeOwner({user_id: owner}, onClose));
  };

  return (
    <>
      <Modal unmountOnClose={true} isOpen={open} backdrop={"static"} size={"lg"}>
        <Loader />
        <ModalHeader>Change Organization Owner</ModalHeader>
        <ModalBody>
          <div className="pl-lg-4">
            <Row>
              <Col lg="12">
                <FormGroup>
                  <SelectCreator
                    label={"NEW OWNER"}
                    closeMenuOnSelect={true}
                    options={user_options}
                    onChange={(e) => handleChange(e)}
                    value={owner}
                    large
                    placeholder={"Select New Owner"}
                  />
                </FormGroup>
              </Col>
            </Row>
          </div>
        </ModalBody>
        <ModalFooter>
          <ZeusButton onClick={handleSubmit} data-cy="submit-btn">
            {"SUBMIT"}
          </ZeusButton>
          <ZeusButton onClick={onClose} data-cy="cancel-btn" className="info-small">
            {"CANCEL"}
          </ZeusButton>
        </ModalFooter>
      </Modal>
    </>
  );
};

ChangeOwner.propTypes = {
  open: PropTypes.bool,
};
export default ChangeOwner;
